<template>
    <div class="surroundingContainer">
        <div class="top">
            <span>行业列表</span> 
        </div>
        <div class="body">
        <a-tabs default-active-key="1" @change="callback">
             <a-tab-pane key="1" tab="行业列表">
                  <div class="container">
                    <div class="containerTop">
                        <a-button type="primary" @click="addmasterCategory" style="margin-right: 5px">新增大类</a-button>
                        <a-button type="primary" @click="editMasterCategory" style="margin-right: 5px; border: 0;" :disabled="selectedRowKeys == ''">编辑大类</a-button>
                        <a-button type="primary" @click="deleteMasterCategory" style="background-color: red; border: 0;">删除大类</a-button>
                    </div>
                    <div class="containerSearch">
                        <a-input class="a_select_self margin_self" v-model=" searchData.industryName" allowClear placeholder="行业大类"  @keyup.enter.native="search"/>
                        <a-input class="a_select_self margin_self" v-model=" searchData.subName" allowClear placeholder="行业子类"  @keyup.enter.native="search"/>
                        <a-button type="primary" @click="search" style="margin: 5px 0">查询</a-button>
                        <a-button type="primary" @click="reset" style="margin-right: 5px">重置</a-button>
                    </div>
                    <div class="containerCenter" id="content_main_center_scroll">
                        <!-- 表格区域 -->
                         <a-table :data-source="dataList" bordered :loading="loading" :pagination="false" ref="dataListRef"
				             :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"  :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type:'radio' }">
                             <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                                  <template scope="text, record, index">
                                    {{ (pagination.current - 1) * 10 + index + 1 }}
                                  </template>
				             </a-table-column>
				             <a-table-column key="industryName" title="行业大类" ellipsis="true" data-index="industryName" />
				             <a-table-column key="subName" title="行业子类" ellipsis="true" data-index="subName" />
				             <a-table-column key="categoryName" title="所属项目" ellipsis="true" data-index="categoryName" />
				             <a-table-column title="操作" width="260px">
					            <template scope="text,record">
						           <a @click="addSubCategory(record)">新增子类</a>
                                   	<a-divider type="vertical" />
						           <a @click="editSubCategory(record)">编辑子类</a>
                                   	<a-divider type="vertical" />
						           <a @click="detailSubCategory(record)">详情</a>
                                   	<a-divider type="vertical" />
                                   <a @click="deleteSubCategory(record)">删除</a>
                                </template>
                             </a-table-column>
                         </a-table>
                          <!-- <Pagination 
                            v-model="pagination.current"
                            :total="pagination.totalCount"
                            show-size-changer
                            :page-size="pagination.pageSize"
                             @onShowSizeChange="onShowSizeChange"
                          ></Pagination> -->
                               <div class="pageBottom">
                               <a-pagination
            v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			@showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="onShowSizeChange"
          />
            </div> 


                    </div>
                   
                  </div>
                   <!-- 新增/编辑行业大类弹窗 -->
        <AddMasterCategory ref="addMasterCategoryRef" :masterCategory="masterCategory" :type="type" :addMasterCategoryVisible="addMasterCategoryVisible" @changeAddVisible="changeAddVisible" @getdata="getList"></AddMasterCategory>
             </a-tab-pane>
             <a-tab-pane key="2" tab="检测类别表" force-render>
                <div class="container">
                    <div class="containerTop">
                        <a-button type="primary" @click="addRelevance" style="margin-right: 5px">新增关联</a-button>
                        <a-button type="primary" @click="deletaAllPollutant" style="margin-right: 5px; background-color: red; border: 0;">批量删除</a-button>
                       
                    </div>
                    <div class="containerSearch">
                        <a-input class="a_select_self margin_self" v-model=" searchData1.industryName" allowClear placeholder="行业大类"  @keyup.enter.native="testSearch"/>
                        <a-input class="a_select_self margin_self" v-model=" searchData1.subName" allowClear placeholder="行业子类"  @keyup.enter.native="testSearch"/>
                        <a-button type="primary" @click="testSearch" style="margin: 5px 0">查询</a-button>
                        <a-button type="primary" @click="testReset" style="margin-right: 5px">重置</a-button>
                    </div>
                    <div class="containerCenter" id="content_main_center_scroll">
                        <!-- 表格区域 -->
                         <a-table :data-source="testList" bordered :loading="loading" :pagination="false" 
				             :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"  :row-selection="{ selectedRowKeys: selectedRowKeys1[pagination1.current], onChange: onSelectChange1 }">
                             <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                                  <template scope="text, record, index">
                                    {{ (pagination1.current - 1) * 10 + index + 1 }}
                                  </template>
				             </a-table-column>
				             <a-table-column key="masterCategory" title="行业大类" ellipsis="true" data-index="masterCategory" />
				             <a-table-column key="subCategory" title="行业子类" ellipsis="true" data-index="subCategory" />
				             <a-table-column key="pollutantName" title="检测类别" ellipsis="true" data-index="pollutantName" />
				             <a-table-column title="操作" width="220px">
					            <template scope="text,record">
						           <a @click="editRelevance(record)">编辑</a>
                                   	<a-divider type="vertical" />
						           <a @click="detailRelevance(record)">详情</a>
                                   	<a-divider type="vertical" />
                                   <a @click="deleteRelevance(record)">删除</a>
                                </template>
                             </a-table-column>
                         </a-table>
            <div class="pageBottom">
                               <a-pagination
            v-model="pagination1.current"
            show-size-changer
            :page-size.sync="pagination1.pageSize"
            :total="pagination1.totalCount"
			@showSizeChange="onShowSizeChange1"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="onShowSizeChange1"
          />
            </div> 
                          <!-- <Pagination 
                            v-model="pagination1.current"
                            :total="pagination1.totalCount"
                            show-size-changer
                            :page-size="pagination1.pageSize"
                             @onShowSizeChange="onShowSizeChange1"
                          ></Pagination> -->
                      </div>
                </div>
             </a-tab-pane>
             <a-tab-pane key="3" tab="污染物报价表">
                  <div class="container">
                      <div class="container">
                    <div class="containerTop">
                        <a-button type="primary" @click="addPullution" style="margin-right: 5px">新增污染物</a-button>
                        <a-button type="primary" @click="batchDelete" style="margin-right: 5px; background-color: red; border: 0;">批量删除</a-button>
                       
                    </div>
                    <div class="containerSearch">
                        
                        <!-- <a-select class="a_select_self margin_self" allowClear placeholder="请选择所属分类" v-model="pollutantId"  @keyup.enter.native="pollutionSearch"
                           show-search :filter-option="filterOption">
                             <a-select-option :value="item.id" v-for="(item, index) in pollutantTypeList" :key="index">
                                 {{ item.pollutantName }}
                            </a-select-option>
                        </a-select>  -->
                         <a-select style="width: 200px; margin: 0 10px;" allowClear placeholder="所属分类" v-model="pollutantId" 
                           show-search :filter-option="filterOption">
                           <a-select-option :value="item.categoryId" v-for="(item, index) in detailList" :key="index">
                                          {{ item.categoryName }}
                                </a-select-option>
                            <!-- <a-select-option :value="item.id" v-for="(item, index) in pollutantTypeList" :key="index">
                                 {{ item.pollutantName }}
                            </a-select-option> -->
                         </a-select>
                        <a-input style="width: 200px; margin-right: 10px;" v-model="factorName" allowClear placeholder="污染物名称" @keyup.enter.native="pollutionSearch"/>
                        <a-button type="primary" @click="pollutionSearch" style="margin: 5px 0">查询</a-button>
                        <a-button type="primary" @click="pollutionReset" style="margin-right: 5px">重置</a-button>
                    </div>
                    <div class="containerCenter" id="content_main_center_scroll">
                        <!-- 表格区域 -->
                         <a-table :data-source="pollutionList" bordered :loading="loading" :pagination="false" 
				             :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"  :row-selection="{ selectedRowKeys: selectedRowKeys2[pagination2.current], onChange: onSelectChange2 }">
                             <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                                  <template scope="text, record, index">
                                    {{ (pagination2.current - 1) * 10 + index + 1 }}
                                  </template>
				             </a-table-column>
				             <a-table-column key="subcategory" title="所属分类" ellipsis="true" data-index="subcategory" />
				             <a-table-column key="factorName" title="污染物名称" ellipsis="true" data-index="factorName" />
				             <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
				             <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
				             <a-table-column key="analysePrice" title="采样费(元)" ellipsis="true" data-index="analysePrice" />
				             <a-table-column key="samplePrice" title="分析费(元)" ellipsis="true" data-index="samplePrice" />
				             <a-table-column key="price" title="单价(元)" ellipsis="true" data-index="price" />
                             <a-table-column title="操作" width="220px">
					            <template scope="text,record">
						           <a @click="editPollution(record)">编辑</a>
                                   	<a-divider type="vertical" />
						           <a @click="detailPollution(record)">详情</a>
                                   	<a-divider type="vertical" />
                                   <a @click="deletePollution(record)">删除</a>
                                </template>
                             </a-table-column>
                         </a-table>
                              <div class="pageBottom">
                               <a-pagination
            v-model="pagination2.current"
            show-size-changer
            :page-size.sync="pagination2.pageSize"
            :total="pagination2.totalCount"
			@showSizeChange="onShowSizeChange2"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="onShowSizeChange2"
          />
            </div> 
                          <!-- <Pagination 
                            v-model="pagination2.current"
                            :total="pagination2.totalCount"
                            show-size-changer
                            :page-size="pagination2.pageSize"
                             @onShowSizeChange="onShowSizeChange2"
                          ></Pagination> -->
                      </div>
                </div>
                  </div>
             </a-tab-pane>
              <!-- <a-tab-pane key="4" tab="生成报价">
                <Environment></Environment>

              </a-tab-pane> -->
        </a-tabs>
        </div>
        <!-- 新增/编辑行业大类弹窗 -->
        <!-- <AddMasterCategory :masterCategory="masterCategory" :type="type" :addMasterCategoryVisible="addMasterCategoryVisible" @changeAddVisible="changeAddVisible" @getdata="getList"></AddMasterCategory> -->
        <!-- 新增/编辑行业子类弹窗 -->
        <SubCategory :type="type" :subCategoryVisible="subCategoryVisible" @changesubVisible="changesubVisible" :masterCategory="masterCategory" @getData="getList"></SubCategory>
        <!-- 新增关联弹窗 -->
        <AddRelevance ref="addRelevanceRef" :addRelevanceVisib="addRelevanceVisib" @changeAddRelevanceVisib="changeAddRelevanceVisib" @changeData="getTestList"></AddRelevance>
        <!--检测类别编辑弹窗 -->
        <EditRelevance :editRelevanceVisib="editRelevanceVisib" :number="number" :analysis="analysis" @changeEditRelevanceVisib="changeEditRelevanceVisib"></EditRelevance>
        <!-- 污染物弹窗 -->
        <Pollution :kind="kind" :pollutionVisible="pollutionVisible" @changePollutionVisible="changePollutionVisible" :polltion="polltion" @getdata="getPollution" @changePollution="changePollution"></Pollution>

    </div>
</template>

<script>
import Environment from './environment.vue'
import Pollution from './components/pollution.vue'
import EditRelevance from './components/editRelevance.vue'
import Pagination from '@/components/pagination/index.vue'
import AddMasterCategory from './components/addMasterCategory'
import SubCategory from './components/subCategory.vue'
import AddRelevance from './components/addRelevance.vue'
import { getIndusryInfoList, getCategoryList, deleteIndustryInfo, getTestType, pollutant, baseFactorDelete, deleteTestType, getPollotantList, getChargeList} from '@/api/surrounding'
import { baseFactor, delete_factor} from '@/api/Industry'
// {deleteIndustryInfo}


export default {
      components: {
        AddMasterCategory,
        SubCategory,
        AddRelevance,
        Pagination,
        EditRelevance,
        Pollution,
        Environment

     },
    data() {
        return {
            // active: '1',
            pollutantId: undefined,
            detailList: '',
            factorName: '',
            // 污染物报价列表
            pollutionList: [],
            // activeKey: {}
            // activeKey: ref('1'),
            searchData: {
                industryName: '',
                subName: ''
            },
            searchData1: {
                industryName: '',
                subName: ''
            },
            scroll_y: 150,
            // 新增大类弹窗
            addMasterCategoryVisible: false,
            subCategoryVisible: false,
            addRelevanceVisib: false,
            editRelevanceVisib: false,
            pollutionVisible: false,
            type: 0,
            number: 0,
            kind: 0,
            //行业列表数据
            dataList: [],
             pagination:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            // pagination:{ 
            //     //分页数据
            //      current : 1,
            //      pageSize: 10,
            //      totalCount: 0
            // },
            pagination1:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            // pagination1:{ 
            //     //分页数据
            //      current : 1,
            //      pageSize: 10,
            //      totalCount: 0
            // },
             pagination2:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            //  pagination2:{ 
            //     //分页数据
            //      current : 1,
            //      pageSize: 10,
            //      totalCount: 0
            // },
            selectedRowKeys: [],
            //添加行业列表的数据
            masterCategory: {
                categoryName: '',
                industryName: '',
                subName: '',
                createBy: '',
                createTime: '',
                // 项目id
                projectId: '',
                id: '',
            },
            // 现有行业子类列表
            // subList: [],
            editData: [],
            //检测类别编辑列表数据
            analysis: {

            },
            // 检测类别列表
            testList: [],
            // 污染物弹窗数据
            polltion: {},
            category: '',
            selectedRowKeys1: {
                 1: []

            },
            relevanceData: {},
            selectedRowKeys2: {
                1: []
            },
            pollutionData: {}
        }
    },
    created() {
        // this.active = this.$route.query.select ? String(this.$route.query.select) : '1'
        // console.log(this.active, 'active=====================')
        // consolelog(this.$route.query.select, 'this.$route.query.select==============')
        //获取行业列表
        this.getList()
        this.callback()
        // //获取检测类别表
        // this.getTestList()
        // // 获取污染物报价表
        // this.getPollution()
        // this.getPollotant()
        this.getCategory()
        this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				// setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() + 260
				// }, 1000)
			})
        
    },
    methods: {
        callback(key) {
              this.$nextTick((res) => {
        switch (key) {
          case '1':
           this.getList()
            break
          case '2':
           this.getTestList()
            break
          case '3':
              this.getPollution()
              this.getPollotant()
            break
        }
      })

        },
         //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
          //获取污染物类别列表
        getPollotant() {
             getChargeList({
                parentId: 1001
              }).then(res=> {
                 if(res.code == 200) {
                    this.detailList = res.data

                } else {
                    this.$message.error(res.msg)
                }
            
             })
            // detailList
            // getPollotantList({
            //     projectId: 2
            // }).then(res => {
            //     if(res.code == 200) {
            //     this.pollutantTypeList = res.data.list
            //     } else {
            //         this.$message.error(res.msg)
            //     }
            // })
        },
        // changePollution(data) {
        //     this.polltion = data
        // },
        // 污染物批量删除
        batchDelete() {
             var _this = this
            var obj =_this.pollutionData
            var ids = []
             for (let i in obj) {
                obj[i].forEach(item => {
                    ids.push(item.id)
                })
          
            }
            console.log(ids, 'ids=====================')
            console.log('111111111111111111111111111111111111')
             this.$confirm({
					title: '是否确认删除?',
					onOk() {
                        baseFactorDelete(ids).then(res => {
                            if(res.code == 200) {
                                _this.selectedRowKeys2 = {}
                                _this.$message.success(res.msg)
                                _this.pollutionData = {}
                                _this.getPollution()

                            } else {
                                _this.$message.error(res.msg)

                            }

                        })
					
					},
					onCancel() {
						_this.$message.warning('你点击了取消')
					},
					// class: 'test',
				})


        },
        // 删除污染物
        deletePollution(row){
             var _this = this
            var id = row.id
           this.$confirm({
					title: '是否确认删除?',
					onOk() {
                        baseFactorDelete(id).then(res => {
                            if(res.code == 200) {
                                _this.$message.success(res.msg)
                                _this.getPollution()

                            } else {
                                _this.$message.error(res.msg)

                            }

                        })
					
					},
					onCancel() {
						_this.$message.warning('你点击了取消')
					},
					// class: 'test',
				})
        },
        //污染物重置
        pollutionReset() {
           
            this.factorName = ''
            this.pollutantId = undefined
             this.getPollution()

        },
        //污染物查询
        pollutionSearch() {
               this.pagination2.current = 1
		    this.pagination2.pageSize = 10
            this.getPollution()

        },
        //获取危害因素列表
        getPollution() {
            baseFactor({
                pageNum: this.pagination2.current,
		        pageSize: this.pagination2.pageSize,
                factorName: this.factorName,
                subcategoryId: this.pollutantId,
                categoryId: 1001,
                
            }).then( res=> {
                if(res.code == 200) {
                    this.pollutionList = res.data
                    this.pagination2.totalCount = res.total
                }else {
                    this.$message.error(res.msg)
                }

            })

        },
        changePollutionVisible(data) {
              this.pollutionVisible = data
        },
        // 获取项目
        getCategory() {
             getCategoryList().then(res =>{
                if(res.code == 200) {
                    res.data.forEach(item => {
                       if (item.id == 2) {
                            this.category = item.categoryName
                       }
                    })
                } else {
                    this.$message.error(res.msg)
                }
                
            })
        },
        //添加污染物
        addPullution() {
            this.polltion = {}
              Object.assign( this.polltion, {
                categoryName:  this.category
            })
            this.pollutionVisible = true
            this.kind = 0
        },
        // 污染物编辑
        editPollution(row) {
            Object.assign(row, {
                categoryName:  this.category
            })
            row.price = Number(row.analysePrice) +  Number(row.samplePrice)
            console.log(row, 'row==================')
            this.polltion = JSON.parse(JSON.stringify(row))
            this.pollutionVisible = true
            this.kind = 1
        },
        //污染物详情
        detailPollution(row) {
            Object.assign(row, {
                categoryName:  this.category
            })
            row.price = Number(row.analysePrice) +  Number(row.samplePrice)
            this.polltion = JSON.parse(JSON.stringify(row))
            this.pollutionVisible = true
            this.kind = 2

        },
        // 检测类别编辑弹窗
        changeEditRelevanceVisib(data) {
            console.log(data, 'data===================')
            this.editRelevanceVisib = data

        },
        //查询检测列表
        testSearch() {
            this.pagination1.current = 1
		    this.pagination1.pageSize = 10
            // this.onShowSizeChange1(1, 10)
            // pageSize
             this.getTestList()

        },
        // 重置查询条件
        testReset() {
            this.searchData1 = {}
            this.getTestList()

        },
           //分页
        onShowSizeChange2(current, pageSize) {
        console.log(current, pageSize);
        this.pagination2.current = current
        this.pagination2.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getPollution()
      },
          //分页
        onShowSizeChange1(current, pageSize) {
        console.log(current, pageSize);
        this.pagination1.current = current
        this.pagination1.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getTestList()
      },
        //   获得检测类别列表
        getTestList() {
            getTestType({
                pageIndex: this.pagination1.current,
		        pageSize: this.pagination1.pageSize,
                industryName: this.searchData1.industryName,
                subName: this.searchData1.subName

            }).then(res => {
                if(res.code == 200) {
                    this.testList = res.data.list
                    this.pagination1.totalCount = res.data.totalCount
                } else {
                    this.$message.error(res.msg)
                }
                
            })

        },
          //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
        // 检测类别表编辑
        editRelevance(row) {
            // row.price = Number(row.analysePrice) +  Number(row.samplePrice)
            console.log(row,'row===========================')
            this.analysis = row
            this.editRelevanceVisib = true
            this.number = 0

        },
        // 检测类别表详情
        detailRelevance(row) {
            this.analysis = row
            this.editRelevanceVisib = true
            this.number = 1


        },

        // 检测类别表删除
        deleteRelevance(row) {
            console.log(row, 'row======================')
            var arr = []
            arr.push(JSON.parse(JSON.stringify(row)))
            console.log(arr, 'arr======================')
             var _this = this
            this.$confirm({
                title: '是否确认删除?',
                onOk() {
                   
            deleteTestType({
                quoteCategoryPollutantList: arr
            }).then( res => {
                if (res.code == 200) {
                    _this.$message.success(res.msg)
                    _this.getTestList()

                } else {
                    _this.$message.error(res.msg)
                }
            })
                
                },
                onCancel() {
                    _this.$message.warning('你点击了取消')
                },
                // class: 'test',
            })





        },   
        // 批量删除检测类别表
        deletaAllPollutant() {
             var _this = this
             var obj =_this.relevanceData
             console.log(_this.relevanceData, 'this.relevanceData=============')
            var ids = []
             for (let i in obj) {
                obj[i].forEach(item => {
                    ids.push(item)
                })
          
            }
            //  for (let i in obj) {
            //     obj[i].forEach(item => {
            //         ids.push(item.id)
            //     })
          
            // }
            console.log(ids, 'ids======================')
            this.$confirm({
                title: '是否确认删除?',
                onOk() {
                   
            deleteTestType({
                quoteCategoryPollutantList:ids
                }).then( res => {
                if (res.code == 200) {
                    _this.$message.success(res.msg)
                    _this.relevanceData = {}
                    _this.selectedRowKeys1 = {}
                    _this.getTestList()

                } else {
                    _this.$message.error(res.msg)
                }
            })
                
                },
                onCancel() {
                    _this.$message.warning('你点击了取消')
                },
                // class: 'test',
            })


        },
        // 检测类别表新增关联
        addRelevance() {
            this.$refs.addRelevanceRef.init()
              this.addRelevanceVisib = true

        },
        changeAddRelevanceVisib() {
            this.addRelevanceVisib = false

        },
        //删除子类
        deleteSubCategory(row) {
            console.log(row, 'row===========================') 
            var _this = this
            this.$confirm({
                title: '是否确认删除?',
                onOk() {
                    deleteIndustryInfo(row.subId).then(res => {
                        if(res.code == 200) {
                            _this.$message.success(res.msg)
                            _this.getList()
                        } else {
                            _this.$message.error(res.msg)
                           

                        }
                    })
                
                },
                onCancel() {
                    _this.$message.warning('你点击了取消')
                },
                // class: 'test',
            })


        },
        //编辑子类
        editSubCategory(row) {
            if(row.subId) {
                  this.masterCategory = {}
            // this.masterCategory.subName = row.subName
            this.$set( this.masterCategory, 'subName', row.subName)
            this.masterCategory.subId = row.subId
            this.masterCategory.categoryName = row.categoryName,
            this.masterCategory.industryName = row.industryName,
             this.masterCategory.id = row.id
            this.type = 5
            this.subCategoryVisible = true

            } else {
                this.$message.warning('请先新增子类，才可编辑子类！')
            }
            console.log(row, 'row========================')
          

        },
        //详情
        detailSubCategory(row) {
             this.masterCategory = {}
            this.type = 4
            this.masterCategory.creator = JSON.parse(JSON.stringify(row.creator))
            this.masterCategory.categoryName = JSON.parse(JSON.stringify(row.categoryName))
            this.masterCategory.industryName = JSON.parse(JSON.stringify(row.industryName))
            this.masterCategory.createTime = JSON.parse(JSON.stringify(row.createTime))
             this.masterCategory.id = JSON.parse(JSON.stringify(row.id))
            this.subCategoryVisible = true

        },
        //新增行业子类
        addSubCategory(row) {
            console.log(row, 'row===================')
            // this.masterCategory.subName = 
            this.masterCategory.categoryName = row.categoryName,
            this.masterCategory.industryName = row.industryName,
             this.masterCategory.projectId = row.projectId
            this.masterCategory.id = row.id
            // 获取现有子类列表
           
            console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
             this.subCategoryVisible = true
             this.type = 3
             console.log(this.subCategoryVisible , 'this.subCategoryVisible =====================')

        },
         changesubVisible(data) {
            this.subCategoryVisible = data
        
         },
        //单项选中
        onSelectChange(selectedRowKeys, val) {
            this.editData = {}
             this.selectedRowKeys = {}
            console.log('111111111111111111111111111')
            console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
            this.selectedRowKeys = selectedRowKeys
            this.editData = val
            console.log(this.editData,'this.editData==============')
				// this.formFlow.cateModule = val[0].name
				// this.selectval = val[0]

        },
          onSelectChange2(selectedRowKeys, val) {
            console.log('111111111111111111111111111')
            console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
            this.selectedRowKeys2[this.pagination2.current] = selectedRowKeys
            this.getPollution()
            this.pollutionData[this.pagination2.current] = val
            console.log(this.selectedRowKeys2,'this.selectedRowKeys2==============')
				// this.formFlow.cateModule = val[0].name
				// this.selectval = val[0]

        },
          onSelectChange1(selectedRowKeys, val) {
            console.log('111111111111111111111111111')
            console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
            this.selectedRowKeys1[this.pagination1.current] = selectedRowKeys
            this.getPollution()
            this.relevanceData[this.pagination1.current] = val
            console.log(this.selectedRowKeys1,'this.selectedRowKeys1==============')
				// this.formFlow.cateModule = val[0].name
				// this.selectval = val[0]

        },
        
         //分页
        onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getList()
      },
        // 查询
        search() {
              this.pagination.current = 1
		    this.pagination.pageSize = 10
            this.getList()

        },
        //重置
        reset() {
            this.searchData = {}
            this.getList()

        },
        // 获得列表数据
        getList() {
            getIndusryInfoList({
                pageIndex: this.pagination.current,
		        pageSize: this.pagination.pageSize,
                industryName: this.searchData.industryName,
                subName: this.searchData.subName,
                projectId: 2
            }).then( res => {
                if (res.code == 200) {
                     this.dataList = res.data.list
                     this.pagination.totalCount= res.data.totalCount
                } else {
                    this.$message.error(res.msg)
                }
            } )

        },
        //新增大类
        addmasterCategory() {
            // 获取项目名称
            getCategoryList().then(res =>{
                if(res.code == 200) {
                    res.data.forEach(item => {
                       if (item.id == 2) {
                            this.masterCategory.categoryName = item.categoryName
                            this.masterCategory.projectId = 2
                            // this.type = 0
                            // this.addMasterCategoryVisible = true
                            this.$refs.addMasterCategoryRef.init({
                                categoryName:  this.masterCategory.categoryName,
                                type: 0

                            })
                            this.masterCategory.industryName = ''
                       }
                    })
                } else {
                    this.$message.error(res.msg)
                }
                
            })
        },
        changeAddVisible(data) {
            this.addMasterCategoryVisible = data
        },
        //编辑大类
        editMasterCategory() {
            this.$refs.addMasterCategoryRef.init({
                                categoryName:  this.editData[0].categoryName,
                                industryName:  this.editData[0].industryName,
                                type: 1,
                                id: this.editData[0].id
                            })
            //  this.masterCategory.categoryName =  this.editData[0].categoryName,
            // // this.masterCategory.industryName = this.editData[0].industryName,
            //  this.$set(this.masterCategory, 'industryName',  this.editData[0].industryName)
            //  this.masterCategory.id = this.editData[0].id
            // console.log(this.masterCategory,'this.masterCategory===========')
            // this.type = 1
            // this.addMasterCategoryVisible = true
        },
        //删除大类
        deleteMasterCategory() {
            
            var _this = this
            var id = _this.editData[0].id
           this.$confirm({
					title: '删除行业大类之后，关联的的行业子类也会被删除，是否确认删除?',
					onOk() {
                        deleteIndustryInfo(id).then(res => {
                            if(res.code == 200) {
                                _this.$message.success(res.msg)
                                _this.getList()
                                _this.selectedRowKeys = ''
                                _this.editData = []

                            } else {
                                _this.$message.error(res.msg)

                            }

                        })
					
					},
					onCancel() {
						_this.$message.warning('你点击了取消')
					},
					// class: 'test',
				})

        },
        // changeDeleteVisible(data) {
        //     this.deleteMasterCategoryVisible = data
        //       console.log(this.deleteMasterCategoryVisible, 'deleteMasterCategoryVisible')
        // }

    }

}
</script>

<style scoped>
.surroundingContainer {
    margin: 0;
    background-color: #fff;
    padding-bottom: 40px;
    overflow: scroll;
    height: 100vh;
}
.top {
    padding: 10px 10px;
    font-size: 18px;
}
/* .container {
    padding: 10px;
} */
/* .containerTop {
    padding: 10px 10px 10px 0;
} */
.pageBottom {
    margin: 10px;
    display: flex;
    flex-direction: row-reverse;
}

</style>